<template>
	<div>
		<v-container grid-list-sm fluid class="pa-0">
			<v-form ref="AmazonLauncherForm">
				<v-layout row wrap class="pt-2">
					<v-flex xs2>
						<v-autocomplete
							outline
							dense
							:rules="[required]"
							class="dense_input mb-3"
							label="Type*"
							clearable
							@change="emitChange()"
							:items="package_types"
							v-model="form.parameters.package_type">
						</v-autocomplete>
					</v-flex>
					<v-flex xs6>
						<v-text-field
							outline
							:rules="[required]"
							class="dense_input mb-3"
							@change="emitChange()"
							v-model="form.parameters.title"
							label="Titre*">
						</v-text-field>
					</v-flex>
					<v-flex xs4>
						<v-text-field
							outline
							:rules="[required]"
							class="dense_input mb-3"
							@change="emitChange()"
							v-model="form.parameters.label"
							label="Label*">
						</v-text-field>
					</v-flex>
				</v-layout>

				<span class="title">
					Sélection des assets
					<v-chip
						label small outline
						class="my-0"
						color="primary"
						v-if="nbAssets > 0">
						{{ nbAssets }} selectionnés
					</v-chip>
				</span>

				<div v-if="nbAssets > 0">
					<div
						class="asset-section elevation-4"
						v-for="(asset, assetIndex) in form.parameters.assets.list"
						:key="asset.filepath">
						<span class="caption d-block">
							<v-btn flat icon @click="removeAsset(assetIndex)" class="ma-0">
								<v-icon>close</v-icon>
							</v-btn>
							{{ asset.filepath }}
						</span>
						<v-layout row wrap>
							<v-flex xs2>
								<v-autocomplete
									outline
									dense
									:rules="[required]"
									class="dense_input"
									label="Type"
									clearable
									@change="onAssetTypeChange(assetIndex)"
									:items="asset_types"
									v-model="asset.asset_type">
								</v-autocomplete>
							</v-flex>
							<v-flex xs2>
								<v-autocomplete
									outline
									dense
									:rules="[]"
									v-if="showRole(asset.asset_type)"
									class="dense_input"
									label="Rôle"
									clearable
									@change="emitChange()"
									:items="asset_roles"
									v-model="asset.role">
								</v-autocomplete>
							</v-flex>
							<v-flex xs5 v-if="asset.asset_type">
								<v-autocomplete
									clearable
									label="Langue"
									outline
									:rules="[]"
									class="dense_input input-lg"
									dense
									:items="languages"
									@change="emitChange()"
									item-text="text"
									item-value="code"
									v-model="asset.language">
								</v-autocomplete>
							</v-flex>
							<v-flex xs3>
								<v-autocomplete
									outline
									dense
									clearable
									:rules="[]"
									v-if="asset.asset_type === 'Audio'"
									class="dense_input"
									label="Audio Type"
									@change="emitChange()"
									:items="audio_types"
									v-model="asset.audio_type">
								</v-autocomplete>
								<v-autocomplete
									outline
									dense
									clearable
									:rules="[]"
									v-if="asset.asset_type === 'Subtitle'"
									class="dense_input"
									label="Subtitle Type"
									@change="emitChange()"
									:items="subtitle_types"
									v-model="asset.subtitle_type">
								</v-autocomplete>
							</v-flex>
						</v-layout>
					</div>
				</div>

				<v-layout class="mt-3 mb-0">
					<v-btn
						color="primary"
						small
						class="mt-0 mx-1 color--text text-none"
						ref="explorer_btn"
						@click="showExplorer = true">
						<v-icon class="mr-1">add</v-icon>
						Fichiers via le filesystem
					</v-btn>
					<v-btn
						color="primary"
						small
						class="mt-0 mx-1 color--text text-none"
						ref="asset_finder_btn"
						@click="showAssetFinder = true">
						<v-icon class="mr-1">add</v-icon>
						Fichiers via asset finder
					</v-btn>
					<v-spacer></v-spacer>
					<v-btn
						v-if="nbAssets > 0"
						color="warning"
						small
						ref="removeFiles_btn"
						class="mt-0 mx-1 color--text text-none"
						@click="form.parameters.assets.list = [];emitChange()">
						<v-icon class="mr-1">close</v-icon>
						Suppprimer les assets
					</v-btn>
				</v-layout>

			</v-form>
		</v-container>

		<v-card class="pa-2 mb-3" v-if="debug">
			<tree-view :data="form" :options="{maxDepth: 3, rootObjectKey: 'Output'}" />
		</v-card>

		<v-card class="pa-2" v-if="debug">
			<tree-view :data="wf_data" :options="{maxDepth: 0, rootObjectKey: 'Job Descriptor'}" />
		</v-card>

		<Explorer
			v-if="showExplorer"
			assetType="file"
			:multiselect="true"
			toolbarTitle="Selectionnez des assets présents sur le filesystem"
			@close="showExplorer = false"
			@selectedAssets="addAssets($event)">
		</Explorer>

		<AssetFinder
			v-if="showAssetFinder"
			:multiselect="true"
			toolbarTitle="Selectionnez des assets via asset finder"
			@close="showAssetFinder = false"
			@selectedAssets="addAssets($event)">
		</AssetFinder>

	</div>
</template>

<script>
import {
	asset_types,
	asset_roles,
	audio_types,
	subtitle_types,
	package_types,
	languages } from '@/pages/packages/amazon_package_global/amazon_enums.js'
import Explorer from '@/components/modal_explorer.vue'
import AssetFinder from '@/components/modal_asset_finder.vue'
export default {
	props: [ 'wf_data', 'debug', 'details' ],
	components: {
		Explorer,
		AssetFinder
	},
	data () {
		return {
			form: {
				isValid: false,
				jobdescriptorID: null,
				parameters: {}
			},
			showExplorer: false,
			showAssetFinder: false,
			selected_assets: [],
			asset_types: asset_types,
			asset_roles: asset_roles,
			audio_types: audio_types,
			subtitle_types: subtitle_types,
			package_types: package_types,
			languages: languages,
			required: v => (v !== '' && v !== null && v !== undefined) || 'Requis'
		}
	},
	computed: {
		nbAssets () {
			try {
				return this.form.parameters.assets.list.length
			} catch (error) {
				return 0
			}
		}
	},
	methods: {
		showRole (asset_type) {
			let needed = [
				'Video',
				'Audio',
				'Subtitle'
			]
			return needed.indexOf(asset_type) !== -1
		},
		addAssets (assets) {
			assets.map(asset => {
				let assetIsNew = true
				this.form.parameters['assets'].list.map(selected_asset => {
					if (selected_asset.filepath === asset.path) {
						assetIsNew = false
					}
				})
				if (assetIsNew) {
					this.form.parameters['assets'].list.push({
						filepath: asset.path,
						asset_type: null,
						role: null,
						language: null,
						audio_type: null,
						subtitle_type: null
					})
				}
			})
			this.$nextTick((arg) => {
				this.emitChange()
			})
		},
		removeAsset (assetIndex) {
			this.form.parameters.assets.list.splice(assetIndex, 1)
			this.$nextTick((arg) => {
				this.emitChange()
			})
		},
		onAssetTypeChange (assetIndex) {
			let assetType = this.form.parameters['assets'].list[assetIndex].asset_type
			let assetObj = {}
			if (assetType === 'Video') {
				assetObj = {
					asset_type: this.form.parameters['assets'].list[assetIndex].asset_type,
					filepath: this.form.parameters['assets'].list[assetIndex].filepath,
					role: this.form.parameters['assets'].list[assetIndex].role,
					language: this.form.parameters['assets'].list[assetIndex].language
				}
			} else if (assetType === 'Dubcard') {
				assetObj = {
					asset_type: this.form.parameters['assets'].list[assetIndex].asset_type,
					filepath: this.form.parameters['assets'].list[assetIndex].filepath,
					language: this.form.parameters['assets'].list[assetIndex].language
				}
			} else if (assetType === 'Audio') {
				assetObj = {
					asset_type: this.form.parameters['assets'].list[assetIndex].asset_type,
					filepath: this.form.parameters['assets'].list[assetIndex].filepath,
					role: this.form.parameters['assets'].list[assetIndex].role,
					language: this.form.parameters['assets'].list[assetIndex].language,
					audio_type: this.form.parameters['assets'].list[assetIndex].audio_type
				}
			} else if (assetType === 'Subtitle') {
				assetObj = {
					asset_type: this.form.parameters['assets'].list[assetIndex].asset_type,
					filepath: this.form.parameters['assets'].list[assetIndex].filepath,
					role: this.form.parameters['assets'].list[assetIndex].role,
					language: this.form.parameters['assets'].list[assetIndex].language,
					subtitle_type: this.form.parameters['assets'].list[assetIndex].subtitle_type
				}
			} else {
				assetObj = {
					asset_type: this.form.parameters['assets'].list[assetIndex].asset_type,
					filepath: this.form.parameters['assets'].list[assetIndex].filepath
				}
			}
			this.$set(this.form.parameters.assets.list, assetIndex, assetObj)
			this.emitChange()
		},
		validate () {
			let validity = this.$refs['AmazonLauncherForm'].validate()
			let nbAsset = this.$commons.deepGet(this.form, 'parameters.assets.list', []).length
			if (nbAsset === 0) validity = false
			return validity
		},
		emitChange () {
			this.form.isValid = this.validate()
			this.$nextTick((arg) => {
				this.$emit('change', [this.form])
			})
		}
	},
	mounted () {
		this.$emit('modal_width', '1200px')
		this.form.parameters = {}
		this.form.jobdescriptorID = this.wf_data.descriptor_id
		this.form.label = this.wf_data.label
		this.form.jobDescriptorVersion = this.wf_data.version_number
		this.wf_data.parameters.map(desc => {
			let defaultValue = ''
			if (desc.default !== '') defaultValue = desc.default
			if (this.details) {
				if (this.details.hasOwnProperty(desc.name)) {
					defaultValue = this.details[desc.name]
				}
			}
			this.form.parameters[desc.name] = defaultValue
		})
	},
	destroyed () {
		this.$emit('modal_width', null)
	}
}
</script>

<style scoped lang="stylus">
.dense_input
	margin-top: 0
	>>>.v-input__slot
		margin-top: 0

>>>.v-input
	margin: 0 .2em
	.v-messages
		min-height: inherit

.asset-section
	border: thin solid var(--v-background-lighten2)
	margin: 10px 0 10px 0
	padding: 0 5px 5px 5px
</style>



// WEBPACK FOOTER //
// src/pages/maestro/jobs/launcher/job_launcher_form_xbox_package.vue